var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('v-textarea',{attrs:{"label":"Escribe tus pasatiempos"},model:{value:(_vm.pasatiempos),callback:function ($$v) {_vm.pasatiempos=$$v},expression:"pasatiempos"}}),_c('v-btn',{attrs:{"block":"","dark":"","color":"indigo darken-4","elevation":"2"},on:{"click":_vm.emitir}},[_vm._v(" Aceptar ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }